"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUser = exports.sign_up_thunk = exports.isAuthenticated = exports.update_details_thunk = exports.sign_out_thunk = exports.sign_in_thunk = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var sign_in_1 = require("../../api/calls/user/authentication/sign_in");
var sign_up_1 = require("../../api/calls/user/firebase/sign_up");
var main_1 = require("./main");
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var doshx_controls_web_1 = require("doshx_controls_web");
var functions_1 = require("../../constants/functions");
var store_1 = require("../../store");
var sign_up_2 = require("../../api/calls/user/lets_trade/sign_up");
var sign_up_update_1 = require("../../api/calls/user/firebase/sign_up_update");
var _devMode = process.env.NODE_ENV !== "production";
// const userActions = createExtraActions();
// const extraReducers = createExtraReducers();
var initialState = {
    user: {
        uid: undefined,
        SumSubApproved: false,
        integration_id: undefined,
        id_number: "",
        email: _devMode ? "desmond@doshex.com" : "",
        password: _devMode ? "123456" : "",
        confirm_password: undefined,
        name: undefined,
        surname: undefined,
        reset_password_otp: undefined,
        client_id: undefined,
        remember_me: true,
        auth_token: "",
        is_loading: false,
        location: undefined,
        facetecDBRef: "",
        facetec: {
            authenticated: false,
            action_authenticated: false,
        },
        // is_saving: false,
    },
};
var sign_in_thunk = (0, toolkit_1.createAsyncThunk)("user/sign_in_thunk", function (arg, _a) {
    var dispatch = _a.dispatch, getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var cookie, state, user, response, client_id, decodedToken, obj;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    cookie = new universal_cookie_1.default();
                    state = getState();
                    user = state.userState.user;
                    return [4 /*yield*/, (0, sign_in_1.sign_in)({
                            email: user.email,
                            password: user.password,
                        })];
                case 1:
                    response = _b.sent();
                    client_id = "";
                    if (process.env.LETS_TRADE_CLIENT_TOKEN) {
                        decodedToken = doshx_controls_web_1.Utilities.parseJwt(process.env.LETS_TRADE_CLIENT_TOKEN);
                        client_id = decodedToken.id;
                    }
                    if (response.success) {
                        obj = __assign(__assign(__assign({}, user), response === null || response === void 0 ? void 0 : response.content), { client_id: client_id });
                        cookie.set("user_state", obj, {
                            sameSite: true,
                        });
                        dispatch((0, exports.setUser)(obj));
                        dispatch((0, main_1.setDrawerOpen)(false));
                    }
                    else {
                        dispatch((0, main_1.setMessageModal)({ title: "Authentication Failed!", messages: [response === null || response === void 0 ? void 0 : response.message] }));
                    }
                    return [2 /*return*/, response];
            }
        });
    });
});
exports.sign_in_thunk = sign_in_thunk;
var sign_out_thunk = (0, toolkit_1.createAsyncThunk)("user/sign_out_thunk", function (arg, _a) {
    var dispatch = _a.dispatch, getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var cookie;
        return __generator(this, function (_b) {
            cookie = new universal_cookie_1.default();
            cookie.remove("user_state");
            // Unset the state.
            dispatch((0, exports.setUser)({
                user: {
                    uid: undefined,
                    integration_id: undefined,
                    email: "",
                    password: "",
                    name: undefined,
                    surname: undefined,
                },
                auth_token: "",
                is_loading: false,
                facetec: {
                    authenticated: false,
                    action_authenticated: false,
                },
            }));
            //Close the drawer.
            dispatch((0, main_1.setDrawerOpen)(false));
            return [2 /*return*/];
        });
    });
});
exports.sign_out_thunk = sign_out_thunk;
var update_details_thunk = (0, toolkit_1.createAsyncThunk)("user/update_details_thunk", function (arg, _a) {
    var dispatch = _a.dispatch, getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var name, surname, email, cell_number, cookie, state, user, newUserObj;
        return __generator(this, function (_b) {
            name = arg.name, surname = arg.surname, email = arg.email, cell_number = arg.cell_number;
            cookie = new universal_cookie_1.default();
            state = getState();
            user = state.userState.user;
            newUserObj = __assign(__assign({}, user), { name: name, surname: surname, email: email, cell_number: (0, functions_1.removeUndefinedProperties)(cell_number) });
            // If cookie was saved before, update it.
            if (cookie.get("user_state")) {
                cookie.set("user_state", newUserObj, {
                    sameSite: true,
                });
            }
            // Update the state.
            dispatch((0, exports.setUser)(newUserObj));
            return [2 /*return*/];
        });
    });
});
exports.update_details_thunk = update_details_thunk;
// const update_password_thunk = createAsyncThunk(
//   "user/update_password_thunk",
//   async (arg: { newPassword: string; currentPassword: string }, { dispatch, getState }) => {
//     const { newPassword, currentPassword } = arg;
//     // Delete the user cookie.
//     const cookie = new Cookie();
//     update_password({
//       current_password: currentPassword,
//       new_password: newPassword,
//     }).then((response: any) => {
//       // setIsSaving(false);
//       if (response.success) {
//         // setIsEditing(false);
//         // Update the state.
//         dispatch(setUser(response.content));
//         // If cookie was saved before, update it.
//         if (cookie.get("user_state")) {
//           cookie.set("user_state", response.content, {
//             sameSite: true,
//           });
//         }
//       } else {
//         dispatch(setMessageModal({ title: "Something went wrong!", messages: [response.message] }));
//       }
//     });
//   }
// );
var sign_up_thunk = (0, toolkit_1.createAsyncThunk)("user/sign_up_thunk", function (arg, _a) {
    var dispatch = _a.dispatch, getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var cookie, state, user, phoneNumber, response, letsTradeUser, credentials, obj;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        return __generator(this, function (_s) {
            switch (_s.label) {
                case 0:
                    cookie = new universal_cookie_1.default();
                    state = getState();
                    user = state.userState.user;
                    phoneNumber = user === null || user === void 0 ? void 0 : user.cell_number.phone_number;
                    if (phoneNumber.startsWith("0")) {
                        phoneNumber = phoneNumber.substring(1);
                    }
                    return [4 /*yield*/, (0, sign_up_1.fireBaseSignUp)({
                            name: (_b = user.name) !== null && _b !== void 0 ? _b : "",
                            display_name: (_c = user.name) !== null && _c !== void 0 ? _c : "",
                            surname: (_d = user.surname) !== null && _d !== void 0 ? _d : "",
                            email: (_e = user.email) !== null && _e !== void 0 ? _e : "",
                            cell_number: user === null || user === void 0 ? void 0 : user.cell_number,
                            phone_number: (_f = user.phone_number) !== null && _f !== void 0 ? _f : (user === null || user === void 0 ? void 0 : user.cell_number.country_code) + phoneNumber,
                            password: (_g = user.password) !== null && _g !== void 0 ? _g : "",
                            referredBy: (_h = user.referralCode) !== null && _h !== void 0 ? _h : "",
                            // birthday: Utilities.formatDateTime(user.birthday ?? new Date(), "YYYY-MM-DD"),
                            get_communication: (_j = user.get_communication) !== null && _j !== void 0 ? _j : false,
                            agrees_terms_and_conditions: (_k = user.agrees_terms_and_conditions) !== null && _k !== void 0 ? _k : false,
                        })];
                case 1:
                    response = _s.sent();
                    if (!response.success) return [3 /*break*/, 6];
                    return [4 /*yield*/, (0, sign_up_2.letsTradeSignUp)({
                            name: (_l = response.content.userProfile) === null || _l === void 0 ? void 0 : _l.name,
                            surname: (_m = response.content.userProfile) === null || _m === void 0 ? void 0 : _m.surname,
                            cell_number: (_o = response.content.userProfile) === null || _o === void 0 ? void 0 : _o.cell_number.phone_number,
                            email: (_p = response.content.userProfile) === null || _p === void 0 ? void 0 : _p.email,
                            password: user.password,
                            // device_id: "",
                            // firebase_token: response.content.userProfile?.firebase_token,
                            get_communication: (_q = response.content.userProfile) === null || _q === void 0 ? void 0 : _q.get_communication,
                            agrees_terms_and_conditions: (_r = response.content.userProfile) === null || _r === void 0 ? void 0 : _r.agrees_terms_and_conditions,
                        })];
                case 2:
                    letsTradeUser = _s.sent();
                    if (!letsTradeUser.success) return [3 /*break*/, 4];
                    credentials = {
                        namibia: {
                            auth_token: letsTradeUser.content.token,
                            integration_id: letsTradeUser.content.user._id,
                            is_active: true,
                        },
                    };
                    return [4 /*yield*/, (0, sign_up_update_1.fireBaseSignUpUpdate)({
                            auth_token: letsTradeUser.content.token,
                            integration_id: letsTradeUser.content.user._id,
                            credentials: credentials,
                        }, response.content.userDocRef)];
                case 3:
                    _s.sent();
                    obj = __assign(__assign(__assign({}, user), letsTradeUser.content), { auth_token: letsTradeUser.content.token, integration_id: letsTradeUser.content.user._id });
                    cookie.set("user_state", obj, {
                        sameSite: true,
                    });
                    dispatch((0, exports.setUser)(obj));
                    dispatch((0, main_1.setDrawerOpen)(false));
                    return [3 /*break*/, 5];
                case 4:
                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [letsTradeUser.message] }));
                    _s.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
                    _s.label = 7;
                case 7: return [2 /*return*/, response];
            }
        });
    });
});
exports.sign_up_thunk = sign_up_thunk;
var slice = (0, toolkit_1.createSlice)({
    name: "user",
    initialState: initialState,
    reducers: {
        setUser: function (state, action) {
            state.user = action.payload;
        },
    },
    extraReducers: function (builder) {
        builder
            .addCase(sign_in_thunk.fulfilled, function (state, action) {
            // console.log("sign_in_thunk.fulfilled", action);
            state.user.is_loading = false;
        })
            .addCase(sign_in_thunk.rejected, function (state, action) {
            // console.log("sign_in_thunk.rejected", action);
            state.user.is_loading = false;
        })
            .addCase(sign_in_thunk.pending, function (state, action) {
            // console.log("sign_in_thunk.pending", action);
            state.user.is_loading = true;
        })
            .addCase(sign_up_thunk.fulfilled, function (state, action) {
            // console.log("sign_up_thunk.fulfilled", action);
            state.user.is_loading = false;
        })
            .addCase(sign_up_thunk.rejected, function (state, action) {
            // console.log("sign_up_thunk.rejected", action);
            state.user.is_loading = false;
        })
            .addCase(sign_up_thunk.pending, function (state, action) {
            // console.log("sign_up_thunk.pending", action);
            state.user.is_loading = true;
        });
    },
});
function isAuthenticated() {
    var store = store_1.redux_store.getState();
    var user = store.userState.user;
    return (user === null || user === void 0 ? void 0 : user.uid) ? true : false;
}
exports.isAuthenticated = isAuthenticated;
exports.setUser = slice.actions.setUser;
exports.default = slice.reducer;
